export default {
  allData: state => state.data,
  selectedUser: state => state.dataUsers,
  activePage: state=> state.page,
  searchString: state => state.search
}
